/* ═════════════════════════════════════════════════════════════════════════════
   SRC/SERVICES/DASHBOARDPARAMS.JS — params de API a partir dos filtros
   ─────────────────────────────────────────────────────────────────────────────
   Funções puras, sem imports de serviço: separadas de dashboardService.js pra
   poderem ser testadas sem subir a cadeia de imports até config/firebase.js
   (que lança em teste sem VITE_FIREBASE_APIKEY). dashboardService.js
   reexporta buildParams para quem já importa de lá.
   ═══════════════════════════════════════════════════════════════════════════ */

export const buildParams = (filters = {}) => {
  const city = filters.city && filters.city !== "todas" ? filters.city : "";
  const npsSegment = filters.npsSegment ?? "";
  const clientType = filters.clientType ?? "";

  let period = filters.period;
  let fk_id_period;

  const hasFilter = city || npsSegment || clientType;

  if (hasFilter && filters.periods?.length) {
    const geralPeriod = filters.periods.find(
      (p) =>
        p.name === filters.period &&
        (!p.city || p.city === "") &&
        (!p.nps_segment || p.nps_segment === "") &&
        (!p.client_type || p.client_type === ""),
    );
    if (geralPeriod) {
      const matchedPeriod = filters.periods.find(
        (p) =>
          (p.city ?? "") === city &&
          (p.nps_segment ?? "") === npsSegment &&
          (p.client_type ?? "") === clientType &&
          p.start_date === geralPeriod.start_date,
      );
      if (matchedPeriod) {
        period = matchedPeriod.name;
        fk_id_period = matchedPeriod.id;
      }
    }
  }

  return {
    period,
    city,
    nps_segment: npsSegment,
    client_type: clientType,
    fk_id_period,
    beneficiary_type:
      filters.beneficiaryType && filters.beneficiaryType !== "todos"
        ? filters.beneficiaryType
        : undefined,
    start_date: filters.dateRange?.start || undefined,
    end_date: filters.dateRange?.end || undefined,
  };
};

// Históricos (todos os períodos) do recorte ativo. Sem período de propósito: a
// série precisa de todos os meses. A API filtra periods.city, nps_segment e
// client_type exatamente pelo valor recebido ("" = geral) — sem estes params
// os gráficos de evolução mostravam o geral mesmo com cidade filtrada.
export const buildHistoryParams = (filters = {}) => {
  const { city, nps_segment, client_type } = buildParams(filters);
  return { city, nps_segment, client_type };
};
